import { Injectable } from '@angular/core';
import { Owner, User, IS_EMPTY } from 'cargo-chief-commons';
import { ACCOUNT_STATUS } from '@domain/constants/app-variables';
import { AccessCacheService } from '@service/access-cache/access-cache.service';

@Injectable({
	providedIn: 'root',
})
export class UsersService {
	constructor(private accessCacheService: AccessCacheService) {}

	public getActiveUsers(userIds: number[] = []): Owner[] {
		let activeUsers = [] as Owner[];
		this.accessCacheService.getAccountUsers().map((user: User) => {
			if (
				user.accountStatus != ACCOUNT_STATUS.INACTIVE &&
				(userIds.length == 0 || userIds.includes(user.id))
			) {
				let owner = {} as Owner;
				owner.userId = user.id;
				if (IS_EMPTY(user.firstName) && IS_EMPTY(user.lastName)) {
					owner.name = user.email;
				} else {
					owner.name = `${user.firstName || ''} ${user.lastName || ''}`;
				}
				owner.selected = false;
				activeUsers.push(owner);
			}
		});
		return activeUsers;
	}

	public getUsersById(userIds: number[]): User[] {
		return this.accessCacheService.getAccountUsers().filter((user: User) => {
			return userIds.includes(user.id);
		});
	}
}
